import React, { useRef, useEffect } from 'react';
import { clickOutside } from '../../reusable/common';
import { SmallAddButton } from './Buttons';
import _ from 'lodash'; // Import lodash for utility functions

const CustomDropdown = ({
    open,
    noData,
    setOpenDropdown,
    onChange,
    onScreenClick,
    addText,
    filterValue,
    marginLeft,
    marginRight
}) => {
    const wrapperRef = useRef("menu");
    clickOutside(wrapperRef, () => {
        setOpenDropdown(false);
    });

    return (
        <div ref={wrapperRef} className={`custom-container position-relative ${marginLeft}`}>
            {open && (
                <div className="custom-dropDown-container position-absolute">
                    <div className="custom-dropdown-options text-left">
                        {filterValue && filterValue.length > 0 ? (
                            filterValue.map((value, i) => (
                                value.icon ? (
                                    <a key={i} className="dropdown-item d-flex align-items-center" onClick={() => {
                                        onChange(value);
                                        setOpenDropdown(false);
                                    }}>
                                        {value.icon && (
                                            <span className="icon-container mr-2">{value.icon}</span>
                                        )}
                                        {value.name}
                                    </a>
                                ) : (
                                        <a key={i} className="" onClick={() => {
                                            onChange(value);
                                            setOpenDropdown(false);
                                        }}>
                                            {value.name ? value.name : value.ticket_name}
                                        </a>
                                    )
                            ))
                        ) : (
                                <p className="my-2 mx-2 mt-1 text-center custom-message">
                                    {noData}
                                </p>
                            )}
                    </div>
                    {addText && (
                        <div className="custom-add-container mx-auto d-flex align-items-center pl-1">
                            <SmallAddButton btnType="secondary" onClick={() => {
                                onScreenClick();
                                setOpenDropdown(false);
                            }}>
                                {addText}
                            </SmallAddButton>
                        </div>
                    )}
                </div>
            )}
            <style>{`
                .custom-dropDown-container {
                    z-index: 100;
                    min-width: 300px;
                    max-width: 455px;
                    max-height: calc(100vh - 96px);
                    background: #fff;
                    left: ${marginRight ? '' : '-15px'};
                    right: ${marginRight ? '-20px' : ''};
                    border-radius: 2px;
                    top: 10px;
                    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.12);
                }
                .custom-dropdown-options {
                    margin-top: 6px;
                    max-height: calc(50vh - 220px);
                    overflow-y: scroll;
                    overflow-x: hidden;
                }
                .custom-dropdown-options > a {
                    display: block;
                    width: 100%;
                    padding: 8px 0px 8px 12px;
                    font-size: 16px;
                    color: #6D7780;
                    word-break: break-all;
                }
                .custom-dropdown-options > a:hover {
                    background: #f3f2f2;
                    color: #6D7780;
                    text-decoration: none;
                    cursor: pointer;
                }
                .custom-add-container {
                    width: 290px;
                    height: 50px;
                    border-top: 0.5px solid #E9ECEF;
                }
                .custom-dropdown-icons {
                    margin-top: 6px;
                }
                .custom-dropdown-icons > a {
                    display: flex;
                    align-items: center;
                    padding: 8px 12px;
                    font-size: 16px;
                    color: #6D7780;
                    cursor: pointer;
                }
                .custom-dropdown-icons > a:hover {
                    background: #f3f2f2;
                    text-decoration: none;
                }
                .custom-dropdown-icons > a .fa-icon {
                    margin-right: 8px;
                }
            `}</style>
        </div>
    );
};

export default CustomDropdown;
